<div class="main-header-menu">
          <a class="home nav-link-home" [ngClass]="highlightHome ? 'homeactive' : 'homeinactive'"
            (click)="navigate(navlinks.home.home.url); toggler('home')">
            <mat-icon class="user-arrow-down homeGrey" style="font-size: 22px">home</mat-icon>
          </a>

          <button type="button" class="p15 main-menu-trigger" [matMenuTriggerFor]="planningMenu">
            <div class="usermenu">
              <div>
                <div class="menu-sub-text">PLANNING</div>
              </div>
              <mat-icon class="menu-arrow-down">expand_more</mat-icon>
            </div>
            <mat-menu class="usermenu" #planningMenu="matMenu">
              <button class="menu-items-text" mat-menu-item (click)="
                navigateExternalUrl(navlinks.planning.alarms.url);
                toggler('planning')
              " *appModuleFga="{moduleName: 'Alarms'}">
                Alarms
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigateExternalUrl(navlinks.planning.allo.url);
                  toggler('planning')
                " *appModuleFga="{moduleName: 'Allo'}">
                Allo
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                navigate(navlinks.planning.companyInfoChange.url);
                toggler('planning')
              " *appFga="{featureId: 'Company Information Change Request Approval'}">
                Company Information Change
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigateExternalUrl(navlinks.planning.costPlanning.url);
                  toggler('planning')
                " *appModuleFga="{moduleName: 'Cost Planning'}">
                Cost Planning
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigateExternalUrl(navlinks.planning.delayedDispatch.url);
                  toggler('planning')
                  " *appModuleFga="{moduleName: 'Delayed Dispatch'}">
                Delayed Dispatch
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                navigateExternalUrl(navlinks.planning.eboi.url); toggler('planning')
                " *appModuleFga="{moduleName: 'EBOI'}">
                EBOI
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                navigateExternalUrl(navlinks.planning.exports.url);
                toggler('planning')
              " *appModuleFga="{moduleName: 'Exports'}">
                Exports
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigateExternalUrl(navlinks.planning.forecastAdmin.url);
                  toggler('planning')
                " *appFga="{featureId: 'Forecast Admin Dashboard'}">
                Forecast Admin Dashboard
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigate(navlinks.planning.fto.url); toggler('planning')
                " *appModuleFga="{moduleName: 'FTOs'}">
                FTOs
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigateExternalUrl(navlinks.planning.group1.url);
                  toggler('planning')
                " *appModuleFga="{moduleName: 'Group I'}">
                Group I
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigate(navlinks.planning.dashboard.url);
                  toggler('planning')
                " *appFga="{featureId: 'Manage Periods'}">
                Manage Periods
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigate(navlinks.planning.masterDock.url);
                  toggler('planning')
                " *appModuleFga="{moduleName: 'Master Dock'}">
                Master Dock
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigate(navlinks.planning.regionTargets.url);
                  toggler('planning')
                " *appModuleFga="{moduleName: 'Region Targets'}">
                Region Targets
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigate(navlinks.planning.scnc.url); toggler('planning')
                " *appModuleFga="{moduleName: 'SCNC'}">
                SCNC
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                navigateExternalUrl(navlinks.planning.taskManager.url);
                toggler('planning')
              " *appModuleFga="{moduleName: 'Task Manager'}">
                Task Manager
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigateExternalUrl(navlinks.planning.tlmsSend.url);
                  toggler('planning')
                " *appModuleFga="{moduleName: 'TLMS Send'}">
                TLMS Send
              </button>
            </mat-menu>
          </button>

          <button type="button" class="p15 main-menu-trigger" [matMenuTriggerFor]="operationsMenu">
            <div class="usermenu">
              <div>
                <div class="menu-sub-text">OPERATIONS</div>
              </div>
              <mat-icon class="menu-arrow-down">expand_more</mat-icon>
            </div>
            <mat-menu class="usermenu" #operationsMenu="matMenu">
              <button class="menu-items-text" mat-menu-item (click)="
                  navigateExternalUrl(navlinks.operations.aet.url);
                  toggler('operations')
                " *appModuleFga="{moduleName: 'AET'}">
                AET
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigate(navlinks.operations.companyInfo.url);
                  toggler('operations')
                " *appModuleFga="{moduleName: 'Company Information Search'}">
                Company Information
              </button>
              <button class="menu-items-text" mat-menu-item
                *appModuleFga="{moduleName: ['Billing Master', 'Logistics Cost Management', 'Cost Master', 'DRC', 'General Costs', 'Expedite Costs', 'Surcharges', 'LP Invoice', 'Billing Summary']}"
                (click)="
                  navigate(navlinks.operations.lpBilling.url);
                  toggler('operations')
                ">
                LP Billing
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                navigateExternalUrl(navlinks.operations.trailerLoadDiagrams.url); toggler('operations')
                " *appModuleFga="{moduleName: 'Trailer Load Diagrams'}">
                Trailer Load Diagrams
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigate(navlinks.operations.uxmxroutes.url); toggler('operations')
                " *appModuleFga="{moduleName: 'US MX Routes'}">
                US MX Routes
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigate(navlinks.operations.wtResolution.url);
                  toggler('operations')
                " *appModuleFga="{moduleName: 'Window Times'}">
                Window Times
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigate(navlinks.operations.returnsReload.url);
                  toggler('operations')
                " *appModuleFga="{moduleName: 'Returns Reload'}">
                Returns Reload
              </button>
            </mat-menu>
          </button>

          <button type="button" class="p15 main-menu-trigger" [matMenuTriggerFor]="reportingMenu">
            <div class="usermenu">
              <div>
                <div class="menu-sub-text">REPORTING</div>
              </div>
              <mat-icon class="menu-arrow-down">expand_more</mat-icon>
            </div>
            <mat-menu class="usermenu" #reportingMenu="matMenu">
              <button class="menu-items-text" mat-menu-item (click)="
                navigateExternalUrl(navlinks.reporting.scheduleDashboard.url);
                  toggler('reporting')
                " *appModuleFga="{moduleName: 'Schedule Dashboard'}">
                Job Scheduler
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                navigateExternalUrlNewWin(navlinks.reporting.reports.url); toggler('reporting')
                " *appModuleFga="{moduleName: 'Reports'}">
                Reports
              </button>
            </mat-menu>
          </button>

          <button type="button" class="p15 main-menu-trigger" [matMenuTriggerFor]="maintenanceMenu">
            <div class="usermenu">
              <div>
                <div class="menu-sub-text">MAINTENANCE</div>
              </div>
              <mat-icon class="menu-arrow-down">expand_more</mat-icon>
            </div>
            <mat-menu class="usermenu" #maintenanceMenu="matMenu">
              <button class="menu-items-text" mat-menu-item (click)="
                  navigate(navlinks.maintenance.notificationGroup.url);
                  toggler('maintenance')
                " *appModuleFga="{moduleName: 'Notification Groups'}">
                Notification Group
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigate(navlinks.maintenance.permissionManagement.url);
                  toggler('maintenance')
                " *appModuleFga="{moduleName: 'APM User'}">
                Permission Management
              </button>
            </mat-menu>
          </button>
</div>